import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
    banner: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        zIndex: 99,
    },
    image: {
        display: 'block',
        height: 96,
        [theme.breakpoints.up('sm')]: {
            height: 96,
        },
        [theme.breakpoints.up('md')]: {
            height: 96,
        },
        [theme.breakpoints.up('lg')]: {
            height: 96,
        },
    },
}));

export default function SzechenyiTervBanner() {
    const classes = useStyles();

    return (
        <div className={classes.banner}>
            <a href="https://anp.hu/igazgatosag/cikk/676">
                <img
                    className={classes.image}
                    src="/images/szechenyi-terv-plusz-2025.jpg"
                    alt="Széchenyi Terv Plusz - Az Európai Unió társfinanszírozásával"
                />
            </a>
        </div>
    );
}
